module.exports = __webpack_public_path__ + "assets/media/dots__add-dots.c7df6b53.svg";